import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-482da324"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "myFormBox"
}
const _hoisted_2 = { class: "date" }
const _hoisted_3 = { class: "for" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_document icon" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Vloga", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.application)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$moment(_ctx.application.createdAt).format("DD.MM.yyyy HH:mm")), 1),
        _createElementVNode("span", {
          class: "status",
          style: _normalizeStyle({ color: _ctx.application.statusColor })
        }, [
          _createElementVNode("span", {
            class: _normalizeClass([_ctx.getStatusClass(_ctx.application.status), "icon"])
          }, null, 2),
          _createTextVNode(" " + _toDisplayString(_ctx.getStatusText(_ctx.application.status)), 1)
        ], 4),
        _createElementVNode("h3", null, _toDisplayString(_ctx.application.form.name), 1),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("forms.application_forum.for")) + ": " + _toDisplayString(_ctx.formJson.PodatkiVlagatelja.Naziv), 1),
        (_ctx.application.administration_fee)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _ctx.application.application_url,
              target: "_blank",
              class: "formDocument"
            }, _hoisted_7, 8, _hoisted_4))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}